import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroBadge() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="inline-flex items-center gap-2 bg-white/60 backdrop-blur-sm border border-white/50 rounded-full pl-1 pr-4 py-1 mb-8 cursor-pointer hover:bg-white/80 transition-colors group shadow-sm" data-id="element-190">
      <div className="relative overflow-hidden bg-blue-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-191">
        <span className="relative z-10" data-id="element-192">Nuevo</span>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer" data-id="element-193" />
      </div>
      <span className="text-sm text-gray-600 font-medium flex items-center gap-1" data-id="element-194">
        Campañas inteligentes marca blanca
        <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" data-id="element-195" />
      </span>
    </motion.div>;
}